import React from 'react';
import ReactDOM from 'react-dom';
import PrismicApp from './PrismicApp';
import './index.css';

ReactDOM.render(
  <PrismicApp />,
  document.getElementById('root'),
);
